import { createTheme, SxProps } from '@mui/material'
import { CSSProperties } from 'react'
import { MuiChip } from './theme-overrides/chip'
import { MuiToggleButton, MuiToggleButtonGroup } from './theme-overrides/toggle-button'
import { MuiButton } from './theme-overrides/button'
import { MuiTooltip } from './theme-overrides/tooltip'
import { MuiPaper } from './theme-overrides/paper'

const FONT = 'DM Sans'
const headerStyles: CSSProperties = { fontWeight: 'bold' }

export const theme = createTheme({
  palette: {
    primary: { main: '#0B2027' },
    secondary: { main: '#474F7A' },
    tertiary: { main: '#81689D' },
    info: { main: '#77B2E6' },
    success: { main: '#03C988' },
    error: { main: '#FF0075' },
    warning: { main: '#FAB95B' },
    common: { white: '#FFFFFF', black: '#000000' },
    background: { paper: '#F3F4F7' },
    text: { primary: '#2F2F2F', secondary: '#707070' },
    divider: '#D3D3D3',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          '& #root': {
            fontFamily: FONT,
            height: '100%',
            overflow: 'hidden',
          },
          height: '100dvh',
        },
        a: {
          textTransform: 'none',
          textDecoration: 'none',
          color: 'inherit',
        },
        button: {
          background: 'none',
          border: 'none',
          fontFamily: 'inherit',
          fontWeight: 500,
          cursor: 'pointer',
        },
      },
    },
    MuiButton,
    MuiToggleButton,
    MuiToggleButtonGroup,
    MuiChip,
    MuiTooltip,
    MuiPaper,
  },
  typography: {
    fontFamily: FONT,
    h1: { fontFamily: FONT, fontSize: 'clamp(32px,3vw ,40px)', ...headerStyles },
    h2: { fontFamily: FONT, fontSize: 'clamp(28px,3vw ,36px)', ...headerStyles },
    h3: { fontFamily: FONT, fontSize: 'clamp(24px,3vw ,32px)', ...headerStyles },
    h4: { fontFamily: FONT, fontSize: 'clamp(20px,3vw ,28px)', ...headerStyles },
    h5: { fontFamily: FONT, fontSize: 'clamp(20px,3vw ,24px)', ...headerStyles },
    h6: { fontFamily: FONT, fontSize: 'clamp(18px,3vw ,20px)', ...headerStyles },
    button: { textTransform: 'none' },
  },
  shape: {
    borderRadius: 6,
  },
})
export type ThemeSxProps = SxProps<typeof theme>
